import { TableRow, TableCell, TableHead } from "@mui/material";
import PropTypes from "prop-types";

export default function HeadComponent({ header = [], ...props }) {
  return (
    <TableHead>
      <TableRow>
        {header.map((headCell) => (
          <TableCell key={headCell.id} {...props}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

HeadComponent.propTypes = {
  /**Array with labaels */
  header: PropTypes.array,
};
